import { Box, Button, CircularProgress, Alert } from "@mui/material";
import React, { useState } from "react";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { axiosFetch } from '../../../utils/AxiosFetch';

import { useDispatch } from "react-redux";

function ForgotPassword(props) {

  const [email, setEmail] = useState("");
  const [resetPwdStatus, setResetPwdStatus] = useState(0);
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const dispatch = useDispatch();



  const handleForgotPassword = () => {
    setLoading(true)
    axiosFetch({
      method: "post",
      url: "/account/forgotpassword",
      requestConfig: {
        "Email": email
      }
    })
      .then((res) => {
        if (res.status === 200) {
          console.log(res.data)
          setLoading(false)
          setResetPwdStatus(res.data);
        }

        if (res.status === 400) {
          setErrMsg(res.data);
          setIsError(true);
          setLoading(false);
        }

      })
      .catch((err) => {
        console.error(err);
      });
  };
  const handleEmail = (e) => {
    setEmail(e.target.value)
    if (isError) {
      setIsError(false)
    }
  }

  return (
    <div className="signin-container" data-testid="forgotpassword-component">
      {resetPwdStatus === 0 ? (
        <>
          <h2 className="login-heading">Forgot Password?</h2>
          <p>
            Enter your email to receive reset password link.
          </p>
          <Box autoComplete="off">
            <ValidatorForm
              // ref="form"
              onError={(errors) => {
                // setIsError(errors.length);
              }}
              onSubmit={() => handleForgotPassword()}
            >
              {isError ? <Alert severity="error">{errMsg}</Alert> : ""}
              <TextValidator
                className="signin-input-container"
                variant="outlined"
                label="Email Address"
                onChange={handleEmail}
                name="email"
                value={email}
                validators={["required", "isEmail"]}
                errorMessages={[
                  "Please fill out this field",
                  "Email Address is not valid",
                ]}
              />

              {/* <Link
                      style={{ float: "right" }}
                      component="button"
                      className="btn-forget"
                      onClick={() => props.forgetpassword()}
                    >
                      Back to Sign-in
                    </Link> */}
              <Button
                data-testid="btn-forget"
                style={{ float: "right" }}
                className="btn-forget"
                component="button"
                onClick={() => props.forgetpassword()}
                to=""
              >
                Back to Login
              </Button>
              {loading ?
                <CircularProgress
                  sx={{
                    position: 'fixed',
                    marginTop: '50px',
                    marginLeft: '160px',
                  }} /> :
                <Button className="login-btn" type="submit">
                  Verify Email
                </Button>}

              {/* <Button className="">
                      <ArrowBackIcon/>Back
                    </Button> */}
            </ValidatorForm>
          </Box>
        </>
      ) : (
        <>
          <h2 className="login-heading">Reset Password Link </h2>
          <h3>Check your email &amp; click the link to reset the password.
            <br />The link will expire in 24 hours</h3>
          <Button
            className="login-btn"
            type="submit"
            onClick={() => props.forgetpassword()}
          >
            Close
          </Button>
        </>
      )}
    </div>
  );
}

export default ForgotPassword;
